import React from 'react'
import { InputText } from '@telavita-core/react-design-kit'
import { MedicalAppointmentFormData } from 'components/MedicalRequestForm/schema'
import { Controller, useFormContext } from 'react-hook-form'

export const SessionQuantityInput = () => {
  const { control } = useFormContext<MedicalAppointmentFormData>()

  return (
    <Controller
      control={control}
      name="sessionQuantity"
      render={({ field, fieldState: { error } }) => (
        <InputText
          {...field}
          onChange={(e) => field.onChange(e.target.value?.replace(/\D/g, ''))}
          handleClearSearchField={() => field.onChange('')}
          floatingLabel="Quantas sessões o médico solicitou?*"
          hasError={Boolean(error?.message)}
          helperMessage={error?.message ?? 'Confira a quantidade recomendada no pedido médico.'}
          helperMessageVariant={error?.message ? 'error' : 'default'}
        />
      )}
    />
  )
}
